import { get } from 'lodash';
import * as React from 'react';

// services
import AnalyticsService from 'modules/analytics-provider/analytics-provider.service';

// types
import IConfig, { WEBSITE_MODE } from '@sitegen/common/constants/config';
import { IAnalyticsConfigData } from 'types/analytics';
import { WIDGET_CONFIG } from '@sitegen/common/constants';

interface IAnalyticsProps {
    config: IConfig;
}

export class AnalyticsProvider extends React.Component<IAnalyticsProps, {}> {
    public componentDidMount() {
        const { config } = this.props;
        const flowType = config.analyticsFlowType || get(
            WIDGET_CONFIG,
            `${config.widgetName}.widgetFlowType`,
            ''
        ) as string;
        const analyticsConfigData: IAnalyticsConfigData = {
            applicationId: config.applicationId,
            widgetName: config.widgetName,
            isAnalyticsEnabled: config.isAnalyticsEnabled,
            analyticsMDMInstallmentId: config.analyticsMDMInstallmentId,
            genomeId: config.genomeId,
            envName: config.envName,
            flowType,
            embedded: (config.mode === WEBSITE_MODE.EMBEDDED)
        };
        AnalyticsService.initAnalytics(analyticsConfigData);
    }

    public render() {
        return null;
    }
}

export default AnalyticsProvider;
